<template>
    <!-- 未来lab -->
    <div class="website-css">
        <MenuHead @func="getMsgFormSon"></MenuHead>
        <!--多方面提升-->
        <div class="head-bg">
            <div class="item-bg"></div>
            <div class="item-left-root">
                <img style="width:1.296rem;height: 0.368rem;position: absolute;right: 4rem;top: 0.5rem"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i9.png"/>
                <font style="width:1.296rem;height: 0.368rem;position: absolute;right: 3.85rem;top: 0.57rem;color: #2B9EFC;font-size: 0.16rem;font-weight: bolder">趣味锻炼大脑</font>
                <font style="width:3.7rem;position: absolute;right: 1.62rem;top:1.0rem;color: black;font-size: 0.14rem;">综合记忆、逻辑、反应、专注、计算和想象等能力对训练计划进行组合，让大脑在多领域任务中得到全面提升，使训练效果更好地迁移至日常生活中。</font>
            </div>
            <div class="item-right-root">
                <img class="item-img animated pulse"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i2.png"/>
            </div>
        </div>
        <!--科学性转化-->
        <div class="head-bg">
            <div class="item-bg"></div>
            <div class="item-left-root">
                <img class="item-img-l animated pulse"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i3.png"/>
            </div>
            <div class="item-right-root">
                <img style="width:1.296rem;height: 0.368rem;position: absolute;left:1rem;top: 0.5rem"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i9.png"/>
                <font style="width:1.296rem;height: 0.368rem;position: absolute;left:1.18rem;top: 0.57rem;color: #2B9EFC;font-size: 0.16rem;font-weight: bolder">多维专属训练</font>
                <font style="width:3.7rem;position: absolute;left: 1.01rem;top:1.0rem;color: black;font-size: 0.14rem;">以不同年龄段及人群认知发展规律和能力提升重点为理论、任务设置、算法等基础，同时根据训练者不同需求和任务表现对训练方案难度进行自动调整，使训练更加具有针对性。</font>
            </div>
        </div>
        <!--个性化推荐-->
        <div class="head-bg">
            <div class="item-bg"></div>
            <div class="item-left-root">
                <img style="width:1.296rem;height: 0.368rem;position: absolute;right: 4rem;top: 0.5rem"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i9.png"/>
                <font style="width:1.296rem;height: 0.368rem;position: absolute;right: 3.85rem;top: 0.57rem;color: #2B9EFC;font-size: 0.16rem;font-weight: bolder">科学定制方案</font>
                <font style="width:3.7rem;position: absolute;right: 1.62rem;top:1.0rem;color: black;font-size: 0.14rem;">基于大脑神经可塑性的原理，在心理学实验范式以及游戏化思维指导下设计趣味性的脑力任务和解决方案，通过各类认知任务，从不同维度训练和刺激大脑。</font>
            </div>
            <div class="item-right-root">
                <img class="item-img animated pulse"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i4.png"/>
            </div>
        </div>
        <!--游戏化机制-->
        <div class="head-bg">
            <div class="item-bg"></div>
            <div class="item-left-root">
                <img class="item-img-l animated pulse"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i5.png"/>
            </div>
            <div class="item-right-root">
                <img style="width:1.296rem;height: 0.368rem;position: absolute;left:1rem;top: 0.5rem"
                     src="https://eletell.oss-cn-beijing.aliyuncs.com/H5_Activity/tzqm-web/i9.png"/>
                <font style="width:1.296rem;height: 0.368rem;position: absolute;left:1.18rem;top: 0.57rem;color: #2B9EFC;font-size: 0.16rem;font-weight: bolder">实时查看数据</font>
                <font style="width:3.7rem;position: absolute;left: 1.01rem;top:1.0rem;color: black;font-size: 0.14rem;">在丰富的认知训练任务的基础之上，采用可视化数据和相应人群对比，让训练者可以清晰看到每一天的成长和进步，让脑力训练的成长轨迹清晰可见。</font>
            </div>
        </div>
        <!-- 媒体关注与报道 end -->
        <web-bottom ref="child"></web-bottom>
    </div>
</template>
<script>
    import '../assets/style/Public-css/img-style.css'
    import ChineseJson from '../assets/json/Chinese-Json.json'
    import EnglishJson from '../assets/json/English-Json.json'
    import {WOW} from 'wowjs'
    import MenuHead from '../components/MenuHead'
    import WebBottom from '../components/WebBottom'

    export default {
        name: 'futureLab',
        components: {
            MenuHead,
            WebBottom,
        },
        metaInfo: {
            title: '未来Lab-北京大象智酷科技有限公司', // set a title
            meta: [
                // set meta
                {
                    name: 'keyWords',
                    content:
                        '100+合作高校及机构,数十个科研应用案例,海量认知行为大数据分析,云计算核心算法模型,强有力的数据研究报告,成熟科学理论支撑',
                },
                {
                    name: 'description',
                    content:
                        '北京大象智酷科技有限公司致力于以前沿脑科学研究成果为基础，依托未来之光系列产品的海量数据，形成内部算法和模型，向脑科学、认知神经科学等相关科研机构及高校提供技术和数据支持。从而推动脑科学、认知神经科学等领域的科学研究和科研成果转化。',
                },
            ],
            // link: [{                 // set link
            //  		rel: 'asstes',
            //   	href: 'https://assets-cdn.github.com/'
            // }]
        },
        data() {
            return {
                ChineseJson: JSON.parse(JSON.stringify(ChineseJson)), //中文配表
                EnglishJson: JSON.parse(JSON.stringify(EnglishJson)), //英文配表
                languageJson: [],
                languageList: [],
            }
        },
        props: {
            msg: String,
        },
        watch: {
            cases() {
                this.$nextTick(() => {
                    // 在dom渲染完后,再执行动画
                    var wow = new WOW({
                        live: false,
                    })
                    wow.init()
                })
            },
        },
        created() {
            // this.langtype = localStorage.getItem("LanguageTypes");
            // console.log("语言类型", this.langtype);
            // this.IFType();
            if (localStorage.getItem('LanguageTypes') == undefined) {
                this.langtype = 1
                this.IFType()
            } else {
                this.langtype = localStorage.getItem('LanguageTypes')
                console.log('语言类型', this.langtype)
                this.IFType()
            }
        },
        mounted() {
            new WOW().init()
        },
        methods: {
            IFType() {
                if (this.langtype == 1) {
                    this.languageJson = this.ChineseJson
                    console.log('中文配表', this.languageJson)
                    this.getList()
                } else {
                    this.languageJson = this.EnglishJson
                    this.getList()
                }
            },
            getMsgFormSon(data) {
                // this.msgFormSon = data;
                console.log('home', data)
                this.langtype = data
                this.IFType()
                this.$refs.child.sing(this.langtype)
            },
            getList() {
                console.log('中文配表', this.languageJson)
                // this.ChineseJson.fo
                this.languageJson.forEach((item) => {
                    if (item.title == 'futureLab') {
                        this.languageList = item.List[0]
                    }
                    console.log(this.languageList)
                })
            },
        },
    }
</script>
<style scoped>
    .head-bg {
        background-color: #F8F8F8;
        position: relative;
        height: 4.5rem;
    }

    .item-bg {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 2.5rem;
        background-color: white
    }

    .item-img {
        width: 2.323rem;
        height: 3.523rem;
        position: absolute;
        bottom: 0;
        left: 1.5rem;
    }

    .item-img-l {
        width: 2.323rem;
        height: 3.523rem;
        position: absolute;
        bottom: 0;
        right: 2.5rem;
    }


    .AboutUs-banner-block img {
        height: 100%;
        width: 100%;
    }

    .AboutUs-banner-BSYD .banner-title p {
        color: #ffffff;
    }

    .Solution-banner .w1200 {
        height: 100%;
    }

    .Solution-banner .wlzg-banner-logo {
        margin-top: 150px;
    }

    .brain-ul li {
        float: left;
        width: 400px;
        height: 300px;
    }

    .school-ul li {
        display: inline-block;
        margin-left: 59px;
        text-align: center;

        flex: 1;
    }

    .school-ul li:nth-of-type(1) {
        margin-left: 0px;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }

    .item-left-root {
        width: 50%;
        height: 2.5rem;
        bottom: 0;
        position: absolute;
    }

    .item-right-root {
        width: 50%;
        height: 2.5rem;
        position: absolute;
        bottom: 0;
        left: 50%;
    }
</style>